import { ProfileProps } from './Profile.props';

import ProfileView from './Profile.view';

const ProfileContainer = (props: ProfileProps) => {
  return <ProfileView />;
};

export default ProfileContainer;
